import { render, staticRenderFns } from "./BookFair2020.vue?vue&type=template&id=4128d80e&scoped=true&"
import script from "./BookFair2020.vue?vue&type=script&lang=js&"
export * from "./BookFair2020.vue?vue&type=script&lang=js&"
import style0 from "./BookFair2020.vue?vue&type=style&index=0&id=4128d80e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4128d80e",
  null
  
)

export default component.exports